import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { CredentialList } from '@/components/credentials/CredentialList';
import { CredentialFormDialog } from '@/components/credentials/CredentialFormDialog';
import type { Credential } from '@/types/api.types';

export function CredentialsPage() {
  const [formOpen, setFormOpen] = useState(false);
  const [editTarget, setEditTarget] = useState<Credential | null>(null);

  function handleEdit(credential: Credential) {
    setEditTarget(credential);
    setFormOpen(true);
  }

  function handleCreate() {
    setEditTarget(null);
    setFormOpen(true);
  }

  function handleFormOpenChange(open: boolean) {
    setFormOpen(open);
    if (!open) setEditTarget(null);
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Credenciais</h1>
          <p className="mt-1 text-sm text-muted-foreground">Gerencie suas credenciais Zenvia</p>
        </div>
        <Button onClick={handleCreate}>
          <Plus className="h-4 w-4" />
          Nova credencial
        </Button>
      </div>

      <Card>
        <CardContent className="pt-6">
          <CredentialList onEdit={handleEdit} />
        </CardContent>
      </Card>

      <CredentialFormDialog
        open={formOpen}
        onOpenChange={handleFormOpenChange}
        credential={editTarget}
      />
    </div>
  );
}
